import { BaseInput, Show } from "shared/components";
import { Card } from "shared/components/Card";
import { TextSkeleton } from "shared/components/skeletons";
import { type LockboxCredentialsState } from "views/settings-integration/integrations/shared/lockboxCredentialsState";

interface LockboxCredentialsCardProps {
  idPrefix: string;
  state: LockboxCredentialsState;
  username: string;
  onUsernameChange: (value: string) => void;
  password: string;
  onPasswordChange: (value: string) => void;
}

export const LockboxCredentialsCard = ({
  idPrefix,
  state,
  username,
  onUsernameChange,
  password,
  onPasswordChange
}: LockboxCredentialsCardProps) => (
  <Card className="w-full p-6 mt-4">
    <p className="text-base font-bold text-content-1000">Credentials</p>
    <div className="mt-6 border-t border-alpha-40 pt-6 space-y-4">
      <Show if={state === "error"}>
        <p className="text-sm text-danger-500">
          Unable to load the saved credentials. Please try again later or
          re-enter them below.
        </p>
      </Show>
      {state === "loading" ? (
        <>
          <TextSkeleton size="lg" />
          <TextSkeleton size="lg" />
        </>
      ) : (
        <>
          <BaseInput
            label="Username"
            required
            id={`${idPrefix}-username`}
            placeholder="Username"
            value={username}
            onChange={onUsernameChange}
          />
          <BaseInput
            label="Password"
            required
            id={`${idPrefix}-password`}
            type="password"
            placeholder="**********************"
            value={password}
            onChange={onPasswordChange}
          />
        </>
      )}
    </div>
  </Card>
);
